import { OperationsDialogColumn, OperationsColumn } from 'app/models/operations.models';

export const COLUMNS: OperationsDialogColumn[] = [
  {
    columnDef: OperationsColumn.OfficerName,
    title: 'Officer Name',
    checkboxDisabled: true,
  },
  {
    columnDef: OperationsColumn.Badge,
    title: 'Badge',
  },
  {
    columnDef: OperationsColumn.Rank,
    title: 'Rank',
  },
  {
    columnDef: OperationsColumn.TotalCitations,
    title: 'Total Citations',
  },
  {
    columnDef: OperationsColumn.TotalWarnings,
    title: 'Total Warnings',
  },
  {
    columnDef: OperationsColumn.LastLoginDT,
    title: 'Last Login DT',
  },
  {
    columnDef: OperationsColumn.LastCitationDT,
    title: 'Last Citation DT',
  },
  {
    columnDef: OperationsColumn.LastWarningDT,
    title: 'Last Warning DT',
  },
  {
    columnDef: OperationsColumn.Last7DaysCitations,
    title: 'Last 7 Days Citations',
  },
  {
    columnDef: OperationsColumn.Last7DaysWarnings,
    title: 'Last 7 Days Warnings',
  },
  {
    columnDef: OperationsColumn.Last30DaysCitations,
    title: 'Last 30 Days Citations',
  },
  {
    columnDef: OperationsColumn.Last30DaysWarnings,
    title: 'Last 30 Days Warnings',
  },
];

export const DEFAULT_OPERATIONS_COLUMNS = [
  OperationsColumn.OfficerName,
  OperationsColumn.Badge,
  OperationsColumn.Rank,
  OperationsColumn.TotalCitations,
  OperationsColumn.TotalWarnings,
  OperationsColumn.LastLoginDT,
  OperationsColumn.LastCitationDT,
  OperationsColumn.LastWarningDT,
  OperationsColumn.Last7DaysCitations,
  OperationsColumn.Last7DaysWarnings,
  OperationsColumn.Last30DaysCitations,
  OperationsColumn.Last30DaysWarnings,
];

export const csvColumns: Record<string, string> = {
  [OperationsColumn.OfficerName]: 'OFFICER',
  [OperationsColumn.Badge]: 'BADGE',
  [OperationsColumn.Rank]: 'RANK',
  [OperationsColumn.TotalCitations]: 'TOTAL_CITATIONS_COUNT',
  [OperationsColumn.TotalWarnings]: 'TOTAL_WARNINGS_COUNT',
  [OperationsColumn.LastLoginDT]: 'LAST_LOGIN_DATE_TIME',
  [OperationsColumn.LastCitationDT]: 'LAST_CITATION_DATE_TIME',
  [OperationsColumn.LastWarningDT]: 'LAST_WARNING_DATE_TIME',
  [OperationsColumn.Last7DaysCitations]: 'LAST_7_DAYS_CITATIONS_COUNT',
  [OperationsColumn.Last7DaysWarnings]: 'LAST_7_DAYS_WARNINGS_COUNT',
  [OperationsColumn.Last30DaysCitations]: 'LAST_30_DAYS_CITATIONS_COUNT',
  [OperationsColumn.Last30DaysWarnings]: 'LAST_30_DAYS_WARNINGS_COUNT',
};
